import React from "react";
import { Card } from "react-bootstrap";

const Doctor = ({ doctor }) => {
  return (
    <>
      <div className="col-lg-4 col-10 mx-auto">
        <Card
          style={{ width: "16rem" }}
          className="border border-0 pb-3 mx-auto"
        >
          <Card.Img variant="top" src={doctor.img} />
          <Card.Body>
            <Card.Title> {doctor.name}</Card.Title>
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export default Doctor;
